import { computed } from 'vue';
import { useShared } from '@othercommerce/foundation';

export function useCart() {
  const shared = useShared();

  const cart = computed(() => {
    return shared.value.cart;
  });

  const items = computed(() => {
    if (cart.value) {
      return cart.value.items;
    }

    return [];
  });

  const count = computed(() => {
    return items.value.length;
  });

  return { cart, items, count };
}

export function useVerifiedCart() {
  const shared = useShared();

  const cart = computed(() => {
    if (shared.value.cart) {
      return shared.value.cart;
    }

    throw new Error('The cart should be available here!');
  });

  return cart;
}
